module.exports = __webpack_public_path__ + "img/right.b36c92e6.png";